export const environment = {
  production: true, 
  apiUrl: '/api/v1',
  googleClientId: '759626146544-7di2hl07jpuhrf36h8jdu8nfou5mgc7r.apps.googleusercontent.com',
  paypalClientId: 'sb'
};  
       